import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ProjectAboutSectionProps {
  description: string;
}

export function ProjectAboutSection({ description }: ProjectAboutSectionProps) {
  const [expanded, setExpanded] = useState(false);
  const isLong = description.length > 280;

  if (!isLong) {
    return (
      <div className="prose prose-sm max-w-none text-muted-foreground leading-relaxed whitespace-pre-line">
        {description}
      </div>
    );
  }

  return (
    <div>
      <div
        className={`prose prose-sm max-w-none text-muted-foreground leading-relaxed whitespace-pre-line transition-all ${
          expanded ? '' : 'line-clamp-4 md:line-clamp-6'
        }`}
      >
        {description}
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setExpanded((v) => !v)}
        className="mt-2 h-8 px-2 text-primary hover:text-primary hover:bg-primary/5"
      >
        {expanded ? (
          <>
            Read less <ChevronUp className="ml-1" />
          </>
        ) : (
          <>
            Read more <ChevronDown className="ml-1" />
          </>
        )}
      </Button>
    </div>
  );
}
